import { render, staticRenderFns } from "./ProcessWorkPermitDZ.vue?vue&type=template&id=18e16459"
import script from "./js/ProcessWorkPermitDZ.js?vue&type=script&lang=js&external"
export * from "./js/ProcessWorkPermitDZ.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports